module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "old_pass"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('div', {
    staticClass: "list_box w700"
  }, [_c('div', {
    staticClass: "y_ititle2"
  }, [_vm._v("國立臺灣大學校總區戶外球場網路抽籤申請書")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("送出申請")]), _vm._v(" "), _c('button', {
    staticClass: "btn_n",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("回上一頁")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jubox"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "tx16 txb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" 申請展延")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請年度")]), _vm._v(" "), _c('td', [_vm._v("106")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請系所")]), _vm._v(" "), _c('td', [_vm._v("資訊工程學系 大學部")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請類別")]), _vm._v(" "), _c('td', [_vm._v("男子籃球隊")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "y_ititle2"
  }, [_vm._v("負責人 / 聯絡人")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tx16 txb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" 更新負責人/聯絡人")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("學號")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("電話")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt15 pb15",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "psbox"
  }, [_vm._v("注意事項")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center tx14",
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" 我已閱讀相關注意事項")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a093fc9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/OldPass.vue
// module id = 1299
// module chunks = 3